module.exports = __webpack_public_path__ + "static/img/Joe-Daniher.2142284.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Daniher.jpg
// module id = 8QCd
// module chunks = 0